import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../service/tekkr-service";

export function useGetFileContentsQuery(fileId: string) {
    return useQuery({
        queryKey: ["file-content", fileId],
        queryFn: async () => {
            const res = await apiClient.getFileContents({
                params: {
                    fileId: fileId,
                },
            });
            if (res.status !== 200) {
                throw new Error("Failed to fetch file contents");
            }
            return res.body;
        },
    });
}
